import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';

import { Evaluation } from 'redux/schemas/models/ai-role-play';
import NvEmoji from 'shared/components/nv-emoji';
import { hexToRgbaString, lowTide } from 'styles/global_defaults/colors';
import { dunes, moss, oasis, sandstone, seafoam } from 'athena/styles/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

const styles = css`
  border-radius: ${quarterSpacing}px;

  &.need-work-status {
    background-color: ${hexToRgbaString(dunes, 0.3)};
    .status-text { color: ${sandstone}; }
  }
  &.good-job-status {
    background-color: ${hexToRgbaString(lowTide, 0.3)};
    .status-text { color: ${oasis}; }
  }
  &.excellent-status {
    background-color: ${hexToRgbaString(seafoam, 0.3)};
    .status-text { color: ${moss}; }
  }
`;

type Props = {
  evaluation?: Evaluation | null;
};

const SubmissionEvaluationStatus = ({ evaluation }: Props) => {
  switch (evaluation) {
    case Evaluation.NEED_WORK:
      return (
        <div css={styles} className='d-flex align-items-center need-work-status py-1 px-2'>
          <NvEmoji icon='wrench' size='smallest' />
          <span className='font-weight-bolder ml-1 status-text text-small'>
            {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.NEEDS_WORK()}
          </span>
        </div>
      );
    case Evaluation.GOOD_JOB:
      return (
        <div css={styles} className='d-flex align-items-center good-job-status py-1 px-2'>
          <NvEmoji icon='thumbs_up' size='smallest' />
          <span className='font-weight-bolder ml-1 status-text text-small'>
            {t.SHARED.GOOD_JOB()}
          </span>
        </div>
      );
    case Evaluation.EXCELLENT:
      return (
        <div css={styles} className='d-flex align-items-center excellent-status py-1 px-2'>
          <NvEmoji icon='trophy' size='smallest' />
          <span className='font-weight-bolder ml-1 status-text text-small'>
            {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.EXCELLENT()}
          </span>
        </div>
      );
    default:
      return (
        <div css={styles} className='d-flex align-items-center py-1 px-2 bg-gray-6'>
          <span className='font-weight-bolder text-small text-gray-2'>
            {t.TIMELINE.COMPLETED()}
          </span>
        </div>
      );
  }
};

export default SubmissionEvaluationStatus;
